export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/shareholder-change.bdc5f249-b67d81.png";